<script setup lang="ts">
const props = defineProps<{
  isLoading?: boolean,
  disabled?: boolean,
  theme?: 'primary' | 'secondary' | 'danger' | 'neutral' | 'light' | 'success' | 'secondary-success',
}>()

const isDisabled = computed(() => props.isLoading || props.disabled)
</script>

<template>
  <button
    :disabled="isDisabled"
    class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed"
    :class="[
      theme === 'primary' || !theme ? 'text-white bg-sky-blue-600 hover:bg-sky-blue-700 focus:ring-sky-blue-500' : '',
      theme === 'secondary' ? 'text-sky-blue-700 bg-sky-blue-100 hover:bg-sky-blue-200 focus:ring-sky-blue-500' : '',
      theme === 'danger' ? 'text-red-700 bg-red-100 hover:bg-red-200 focus:ring-red-500' : '',
      theme === 'neutral' ? 'text-gray-700 bg-gray-200 hover:bg-gray-100 focus:ring-gray-500' : '',
      theme === 'light' ? 'text-sky-blue-900 bg-gray-50 hover:bg-gray-200 focus:ring-gray-500' : '',
      theme === 'success' ? 'text-white/90 bg-green-cucumber-500 hover:bg-green-cucumber-600 focus:ring-green-cucumber-500' : '',
      theme === 'secondary-success' ? 'text-green-cucumber-700 bg-green-cucumber-100 hover:bg-green-cucumber-200 focus:ring-green-cucumber-500' : '',
    ]"
    >
      <Loader v-if="isLoading" />

      <slot />
  </button>
</template>